import { render } from "./EditTraineeModal.vue?vue&type=template&id=671daf8b&scoped=true"
import script from "./EditTraineeModal.vue?vue&type=script&lang=js"
export * from "./EditTraineeModal.vue?vue&type=script&lang=js"

import "./EditTraineeModal.vue?vue&type=style&index=0&id=671daf8b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671daf8b"]])

export default __exports__